const SEARCH_CRAWLERS = [
  'bot',
  'bingpreview',
  'contentkingbot',
  'crawler',
  'crawling',
  'googlebot',
  'lighthouse', // lighthouse crawls to simulate GSC, adding to search crawlers
  'prerender',
  'spider',
  'robot',
  'yandex',
];

export const isSearchCrawler = (userAgent: string): boolean => {
  return SEARCH_CRAWLERS.some((crawler) =>
    userAgent?.toLowerCase().includes(crawler.toLowerCase()),
  );
};
